/* Springsioux v5 — ribbon, curtain, small page helpers (vanilla, no deps) */
(function(){
  var doc=document, html=doc.documentElement;
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- arriving curtain: drop the class once its CSS animation is over ---------- */
  if(html.classList.contains('v5c')){ setTimeout(function(){ html.classList.remove('v5c','v5c-zr','v5c-sx'); }, reduce?50:1300); }

  /* ---------- helpers ---------- */
  function ready(fn){ if(doc.readyState!=='loading') fn(); else doc.addEventListener('DOMContentLoaded',fn); }
  function clamp(v,a,b){ return Math.max(a,Math.min(b,v)); }

  /* ---------- curtain + navigation (shared by ribbon) ---------- */
  function crossTo(href, key, side, color, txtColor, label){
    if(reduce){ location.href=href; return; }
    try{ sessionStorage.setItem('v5c', key); }catch(e){}
    var c=doc.createElement('div'); c.className='v5-curtain';
    c.style.setProperty('--c',color); c.style.setProperty('--t',txtColor);
    c.style.setProperty('--from', side==='r' ? 'inset(0 0 0 100%)' : 'inset(0 100% 0 0)');
    c.innerHTML='<span></span>'; c.firstChild.textContent=label||'';
    doc.body.appendChild(c);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ c.classList.add('go'); }); });
    setTimeout(function(){ location.href=href; }, 640);
  }
  window.v5CrossTo=crossTo;

  /* =====================================================================
     RIBBON
     ===================================================================== */
  var NS='http://www.w3.org/2000/svg';
  function el(tag,attrs){ var n=doc.createElementNS(NS,tag); for(var k in attrs) n.setAttribute(k,attrs[k]); return n; }

  function Ribbon(root){
    var d=root.dataset, side=d.side==='r'?'r':'l';
    var color=d.color||'#2a4c39', shade=d.shade||'#1b3226', hi=d.hi||'rgba(255,255,255,.22)';
    var txt=(d.text||'').toUpperCase(), txtColor=d.txtColor||'rgba(243,240,226,.88)';
    var link=root.querySelector('a.v5-rib-link'), href=link?link.getAttribute('href'):'/';
    var mobile=window.innerWidth<768;
    var H=mobile?24:32, REST=mobile?118:210, W=window.innerWidth, CY=80;
    var L=REST, DY=7, dragging=false, sx=0, sy=0, sL=0, moved=0, raf=0, gone=false;

    var svg=el('svg',{width:W,height:160,viewBox:'0 0 '+W+' 160','aria-hidden':'true',focusable:'false'});
    var uid='r'+Math.random().toString(36).slice(2,7);
    var defs=el('defs',{});
    var path=el('path',{id:uid+'c',fill:'none'});
    defs.appendChild(path); svg.appendChild(defs);
    var peek=el('g',{'class':'v5-peek'}), sway=el('g',{'class':'v5-sway'});
    var body=el('path',{'class':'v5-body v5-grab',fill:color});
    var fold=el('path',{fill:'rgba(0,0,0,.28)'});
    var hl=el('path',{fill:'none',stroke:hi,'stroke-linecap':'round'});
    var lo=el('path',{fill:'none',stroke:'rgba(0,0,0,.22)','stroke-width':'1.2'});
    var text=el('text',{fill:txtColor,'font-size':mobile?'9.5':'11.5','font-family':'Jost, sans-serif','font-weight':'600','letter-spacing':mobile?'2.4':'3.2','dominant-baseline':'central'});
    var tp=el('textPath',{href:'#'+uid+'c',startOffset:side==='l'?'18':'4'}); tp.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href','#'+uid+'c');
    var rep=''; for(var i=0;i<14;i++) rep+=txt+'      '; tp.textContent=rep; text.appendChild(tp);
    var hit=el('circle',{'class':'v5-grab',r:mobile?28:34,fill:'transparent'});
    sway.appendChild(body); sway.appendChild(hl); sway.appendChild(lo); sway.appendChild(text); sway.appendChild(fold); sway.appendChild(hit);
    peek.appendChild(sway); svg.appendChild(peek);
    if(link) link.after(svg); else root.appendChild(svg);
    root.style.setProperty('--w',W+'px');

    function X(x){ return side==='l' ? x : W-x; }
    function render(){
      var sag=4+10*(1-clamp((L-REST)/220,0,1));
      var p0={x:-6,y:0}, p2={x:L,y:DY}, p1={x:L*0.5,y:DY*0.2+sag};
      var N=28, top=[], bot=[], ctr=[];
      for(var i=0;i<=N;i++){
        var t=i/N, mt=1-t;
        var x=mt*mt*p0.x+2*mt*t*p1.x+t*t*p2.x, y=mt*mt*p0.y+2*mt*t*p1.y+t*t*p2.y;
        var tx=2*mt*(p1.x-p0.x)+2*t*(p2.x-p1.x), ty=2*mt*(p1.y-p0.y)+2*t*(p2.y-p1.y);
        var ln=Math.sqrt(tx*tx+ty*ty)||1, nx=-ty/ln, ny=tx/ln;
        var w=H/2;
        ctr.push([x,y,tx/ln,ty/ln]);
        top.push([x+nx*w, y+ny*w]); bot.push([x-nx*w, y-ny*w]);
      }
      var e=ctr[N], dv=H*0.85, notch=[e[0]-e[2]*dv, e[1]-e[3]*dv];
      var f=function(pt){ return X(pt[0]).toFixed(1)+','+(CY+pt[1]).toFixed(1); };
      var dB='M'+f(top[0]); for(i=1;i<=N;i++) dB+=' L'+f(top[i]);
      dB+=' L'+f(notch); for(i=N;i>=0;i--) dB+=' L'+f(bot[i]); dB+=' Z';
      body.setAttribute('d',dB);
      var dF='M'+f(top[0])+' L'+f(top[3])+' L'+f(bot[3])+' L'+f(bot[0])+' Z'; fold.setAttribute('d',dF);
      var dH='', dL='';
      for(i=1;i<N;i++){ var c=ctr[i], nx2=-c[3], ny2=c[2];
        dH+=(i===1?'M':' L')+X(c[0]+nx2*H*0.22).toFixed(1)+','+(CY+c[1]+ny2*H*0.22).toFixed(1);
        dL+=(i===1?'M':' L')+X(c[0]-nx2*H*0.36).toFixed(1)+','+(CY+c[1]-ny2*H*0.36).toFixed(1); }
      hl.setAttribute('d',dH); hl.setAttribute('stroke-width',(H*0.2).toFixed(1));
      lo.setAttribute('d',dL);
      var dc='';
      if(side==='l'){ for(i=0;i<=N;i++) dc+=(i?' L':'M')+X(ctr[i][0]).toFixed(1)+','+(CY+ctr[i][1]).toFixed(1); }
      else { for(i=N;i>=0;i--) dc+=(i===N?'M':' L')+X(ctr[i][0]).toFixed(1)+','+(CY+ctr[i][1]).toFixed(1); }
      path.setAttribute('d',dc);
      hit.setAttribute('cx',X(e[0]-H).toFixed(1)); hit.setAttribute('cy',(CY+e[1]).toFixed(1));
    }
    render();

    function threshold(){ return Math.min(W*0.3, 320); }
    function animateTo(tL,tDY,ms,cb){
      cancelAnimationFrame(raf);
      var fL=L, fD=DY, t0=performance.now();
      (function step(now){
        var k=clamp((now-t0)/ms,0,1), c1=1.5, e2=1+(c1+1)*Math.pow(k-1,3)+c1*Math.pow(k-1,2);
        L=fL+(tL-fL)*e2; DY=fD+(tDY-fD)*e2; render();
        if(k<1) raf=requestAnimationFrame(step); else if(cb) cb();
      })(t0);
    }
    function go(){
      if(gone) return; gone=true;
      root.classList.add('drag');
      animateTo(W*1.15, 0, 620);
      crossTo(href, d.key||'zr', side==='l'?'l':'r', d.curtain||color, d.curtainText||'#efe9db', d.label||'');
    }

    function down(e){
      if(e.button!==undefined && e.button!==0) return;
      dragging=true; moved=0; sx=e.clientX; sy=e.clientY; sL=L;
      root.classList.add('drag'); root.classList.remove('hint');
      try{ e.target.setPointerCapture(e.pointerId); }catch(err){}
      e.preventDefault();
    }
    function move(e){
      if(!dragging) return;
      var dx=side==='l' ? e.clientX-sx : sx-e.clientX;
      moved=Math.max(moved, Math.abs(e.clientX-sx)+Math.abs(e.clientY-sy));
      L=Math.max(REST*0.85, sL+dx); DY=clamp((e.clientY-sy)*0.6,-70,70);
      cancelAnimationFrame(raf); raf=requestAnimationFrame(render);
    }
    function up(){
      if(!dragging) return; dragging=false;
      if(moved<6 || (L-REST)>threshold()){ go(); return; }
      root.classList.remove('drag');
      animateTo(REST, 7, 520);
    }
    root.querySelectorAll('.v5-grab').forEach(function(g){ g.addEventListener('pointerdown',down); });
    window.addEventListener('pointermove',move,{passive:true});
    window.addEventListener('pointerup',up); window.addEventListener('pointercancel',up);
    if(link) link.addEventListener('click',function(e){ if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1) return; e.preventDefault(); go(); });

    window.addEventListener('resize',function(){ W=window.innerWidth; svg.setAttribute('width',W); svg.setAttribute('viewBox','0 0 '+W+' 160'); render(); });
    window.addEventListener('pageshow',function(ev){ if(ev.persisted){ gone=false; root.classList.remove('drag'); L=REST; DY=7; render(); var c=doc.querySelector('.v5-curtain'); if(c) c.remove(); } });

    try{ if(!sessionStorage.getItem('v5hint')){ sessionStorage.setItem('v5hint','1');
      setTimeout(function(){ root.classList.add('hint'); animateTo(REST+26,4,700,function(){ animateTo(REST,7,700); }); }, 1400);
      setTimeout(function(){ root.classList.remove('hint'); }, 5200); } }catch(e){}
  }

  /* =====================================================================
     PAGE HELPERS
     ===================================================================== */
  ready(function(){
    doc.querySelectorAll('[data-v5-ribbon]').forEach(function(r){ try{ new Ribbon(r); }catch(e){ if(window.console) console.warn('v5 ribbon',e); } });

    /* split entrance: chat off on phones */
    if(doc.querySelector('[data-sx-split]')) html.classList.add('v5-split');

    /* product page: hide the chat bubble while the sticky add bar is up (phones) */
    var bar=doc.querySelector('[data-zx-sticky]');
    if(bar && 'MutationObserver' in window){
      var sync=function(){ html.classList.toggle('v5-nochat', bar.classList.contains('on')); };
      new MutationObserver(sync).observe(bar,{attributes:true,attributeFilter:['class']}); sync();
    }

    /* ZR shop: scent filters collapsed behind one button */
    doc.querySelectorAll('.zr-filters').forEach(function(f){
      if(f.dataset.v5) return; f.dataset.v5='1';
      var active=/filter\.(p|v)\./.test(location.search);
      var wrap=doc.createElement('div'); wrap.className='v5-fwrap'+(active?' open':'');
      f.parentNode.insertBefore(wrap,f); wrap.appendChild(f);
      var fr=(html.lang||'fr').indexOf('fr')===0;
      var b=doc.createElement('button'); b.type='button'; b.className='v5-ftoggle'; b.setAttribute('aria-expanded',active?'true':'false');
      b.innerHTML='<span>'+(fr?'Filtrer par senteur':'Filter by scent')+'</span><i aria-hidden="true">▾</i>';
      wrap.parentNode.insertBefore(b,wrap);
      b.addEventListener('click',function(){ var o=!wrap.classList.contains('open'); wrap.classList.toggle('open',o); b.setAttribute('aria-expanded',o?'true':'false'); });
    });

    /* Springsioux world: designer index hover image + new-in tabs */
    doc.querySelectorAll('[data-sx-index]').forEach(function(ix){
      var fig=ix.querySelector('.sxw-ix-fig'), img=fig&&fig.querySelector('img');
      if(!fig||!img) return;
      var fine=window.matchMedia('(hover:hover)').matches;
      ix.querySelectorAll('[data-img]').forEach(function(a){
        a.addEventListener('mouseenter',function(){ if(!fine) return; if(a.dataset.img){ img.src=a.dataset.img; fig.classList.add('on'); } ix.classList.add('hov'); });
        a.addEventListener('mouseleave',function(){ fig.classList.remove('on'); ix.classList.remove('hov'); });
      });
      ix.addEventListener('mousemove',function(e){ if(!fine) return; var r=ix.getBoundingClientRect(); fig.style.transform='translate('+(e.clientX-r.left+24)+'px,'+(e.clientY-r.top-120)+'px)'; });
    });
    doc.querySelectorAll('[data-sx-tabs]').forEach(function(t){
      var btns=t.querySelectorAll('[data-tab]'), panes=t.querySelectorAll('[data-pane]');
      btns.forEach(function(b){ b.addEventListener('click',function(){
        btns.forEach(function(x){ x.setAttribute('aria-selected', x===b?'true':'false'); });
        panes.forEach(function(p){ p.hidden = p.dataset.pane!==b.dataset.tab; });
      }); });
    });

    /* reveal-on-scroll for v5 blocks */
    var rv=doc.querySelectorAll('[data-v5-in]');
    if(rv.length){
      if(reduce || !('IntersectionObserver' in window)){ rv.forEach(function(x){ x.classList.add('in'); }); }
      else { var io=new IntersectionObserver(function(en){ en.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); io.unobserve(x.target); } }); },{rootMargin:'0px 0px -10% 0px'}); rv.forEach(function(x){ io.observe(x); }); }
    }
  });
})();
/* v5.2 — on phones the ribbon slides away while the page scrolls, so it never sits on a product card mid-scroll */
(function(){
  if(!window.matchMedia || !matchMedia('(max-width:767px)').matches) return;
  var h=document.documentElement, t;
  window.addEventListener('scroll',function(){
    if(h.querySelector('.v5-rib.drag')) return;
    h.classList.add('v5-scrolling'); clearTimeout(t);
    t=setTimeout(function(){ h.classList.remove('v5-scrolling'); },650);
  },{passive:true});
})();
